export default "__VITE_ASSET__Ca4FVX00__"